import { use } from 'react';
import CommonContext from '@contexts/CommonContext';

export default function useCommonConfig() {
  const context = use(CommonContext);
  if (!context) throw new Error('CommonContext must be use inside provider');

  return context;
}
